import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { FichaMedica } from '../models/fichaMedica';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/FichaMedica';

@Injectable({
  providedIn: 'root'
})
export class FichaMedicaService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(entidad: FichaMedica, ausentismo: boolean)
  {
    return this._http.post<any>({ url: baseUrl + '/Save?ausentismo=' + ausentismo, body: entidad, cacheMins: 0 });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }

  UpdateProfileAdjunto(data, tabla: string): Observable<any> {
    return this._http.post<any>({ url: baseUrl + '/UpdateProfileAdjunto?tabla=' + tabla, body: data, cacheMins: 0 })
  }

}

